module.exports = __webpack_public_path__ + "img/C07TechRamChampion_ua.696c7a60.webp";